import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { frontendUrl } from '../../../../environments/environment';
import { CompanyStructured, InviteLink } from '../../../lib/interfaces/company';
import { DbLicense } from '../../../lib/interfaces/license';
import { checkboxRole } from '../../../lib/interfaces/roles';
import { User } from '../../../lib/interfaces/user';
import { AppdataService } from '../../../service/appdata.service';
import { ClipboardService } from '../../../service/clipboard.service';
import { CompaniesService } from '../../../service/companies.service';
import { SnackService } from '../../../service/snack.service';
import { EditUserGatesComponent } from '../edit-user-gates/edit-user-gates.component';
import { GenerateInviteLinkComponent } from '../generate-invite-link/generate-invite-link.component';

interface NewUser {
    id?: string;
    prename: string;
    lastname: string;
    email: string;
    role: string[];
}


@Component({
    selector: 'app-show-user',
    standalone: false,
    templateUrl: './show-user.component.html',
    styleUrl: './show-user.component.scss'
})
export class ShowUserComponent implements OnInit {
    // Injections
    readonly data = inject<any>(MAT_DIALOG_DATA);
    readonly dialogRef = inject(MatDialogRef<ShowUserComponent>);
    dialog = inject(MatDialog);
    appData = inject(AppdataService);
    companyService = inject(CompaniesService);
    snack = inject(SnackService);
    private clipboardService = inject(ClipboardService);

    // Variables
    loading: boolean = false;
    openAddUser: boolean = false;
    openEditUser: boolean = false;

    // Objects
    roleList: checkboxRole[] = [];
    userList: any[] = [];
    companyList: CompanyStructured[] = [];
    newUser: NewUser = {
        prename: '',
        lastname: '',
        email: '',
        role: []
    }

    // Functions
    async ngOnInit() {
        this.appData.roles.subscribe(async data => {
            if (data) {
                this.roleList = [...data];
                this.roleList.forEach(role => {
                    role.active = false;
                });
                this.loading = true;
                await this.loadUserByCompanyId(this.data.companyId);
                this.loading = false;
            }
        });

    }

    public editInviteLink(link: InviteLink): void {
        let c = this.companyList.find(c => c.companyId === link.companyId)
        this.dialog.open(GenerateInviteLinkComponent, {
            autoFocus: false,
            panelClass: "small-dialog",
            data: {
                link,
                companyId: link.companyId,
                roleList: this.roleList,
                companyData: c
            },
        });
    }

    public async deleteInviteLink(id:string, companyId:string):Promise<void>{
        const c = confirm("Are you sure you want to delete this invite link?")
        if (c) {
            const result = await this.companyService.deleteInviteLink(id);
            if (result === false) {
                return;
            }
            let co = this.companyList.find(c => c.companyId === companyId);
            if (co) {
                co.companyInviteLinkList = co.companyInviteLinkList?.filter(l => l.id !== id);
            }
        }
    }
    async generateInviteLink(companyId: string, userId: string | undefined = undefined) {
        let licenseId = this.data.licenseId;
        let c = this.companyList.find(c => c.companyId === companyId)

        if (!licenseId) {
            // let l = await this.companyService.getLicenseById(licenseId);
            if (c) {
                licenseId = c.license.licenseId;
            }
            else {
                this.snack.error({ headline: "Companylicence Not Found", text: "The specified companylicense does not exist." });
                return;
            }

        }

        let dia = this.dialog.open(GenerateInviteLinkComponent, {
            panelClass: "small-dialog",
            autoFocus: false,
            data: {
                userId,
                roleList: this.roleList,
                inviteLink: null,
                licenseId,
                companyData: c
            }
        });

        dia.afterClosed().subscribe(async result => {
            if (result) {
                this.snack.success({ text: 'Invite link generated successfully!', headline: "Success" });
                this.companyList.forEach(company => {
                    if (company.companyId === companyId) {
                        company.companyInviteLinkList?.push(result)
                    }
                });
            }
        });
    }


    close() {
        this.dialogRef.close();
    }
    async onRoleSelect() {
        let roles = this.roleList.filter(r => r.active === true);
        this.newUser.role = roles.map(r => r.id);

    }
    validateNewUser(): boolean {
        if (
            !this.newUser.prename ||
            this.newUser.prename == "" ||
            !this.newUser.lastname ||
            this.newUser.lastname == "" ||
            this.newUser.role.length === 0 || this.newUser.email == ""
        ) {
            this.snack.error({ headline: "Missing Data", text: "Some Date are missing." });
            return false;
        }
        return true;
    }
    async addNewUser(license: DbLicense, companyId: string) {
        if (!license) {
            return;
        }
        if (this.validateNewUser() === false) return;

        this.loading = true;
        let result: User | false = await this.companyService.addUserForLicense({
            prename: this.newUser.prename,
            lastname: this.newUser.lastname,
            email: this.newUser.email,
            role: this.newUser.role,
            licenseId: license.licenseId,
            companyId: companyId,
            mustChangePassword: true,
        });

        if (result === false) {
            this.loading = false;
            return;
        }

        // console.log("Adding Result", result);

        this.companyList.forEach(c => {
            if (c.companyId === companyId) {
                c.user.push(result);
                console.log("Company Found - User added", c)
                this.newUser = {
                    prename: '',
                    lastname: '',
                    email: '',
                    role: []
                };
            }

        })
        this.loading = false;
        this.openAddUser = false;
        this.openEditUser = false;
        this.companyList.forEach(company => {
            console.log(company);
            if (company.license.licenseId === license.licenseId) {
                company.license.freeSeats -= 1;
            }

        });
    }
    async closeUserDetails() {
        this.openAddUser = false;
        this.openEditUser = false;
        this.newUser = {
            prename: '',
            lastname: '',
            email: '',
            role: []
        };
        this.roleList.forEach(role => role.active = false);
    }
    async deleteUserFromCompany(user: User, companyId: string, license: DbLicense) {
        console.log("User to delete", user);
        let c = confirm("Do you really wnat to delete the User? The Company License will get +1.")

        if (!c) return;

        this.loading = true;
        let deleteResult = await this.companyService.deleteUserFromCompany(user.id, companyId, license.licenseId);
        this.loading = false;
        if (deleteResult === false) {
            return;
        }

        license.freeSeats = license.freeSeats + 1;
        this.companyList.forEach(async c => {
            if (c.companyId === companyId) {
                c.user = c.user.filter(u => u.id !== user.id);
            }
        });

    }
    async saveUser() {
        if (this.validateNewUser() === false) return;
        this.loading = true;
        let result = await this.companyService.updateUserForCompany({
            prename: this.newUser.prename,
            lastname: this.newUser.lastname,
            role: this.newUser.role,
            id: this.newUser.id
        });
        this.loading = false;
    }
    async editUser(user: User) {
        if (!user.id) return;
        this.newUser = { ...this.newUser, ...user };
        console.log(this.newUser);

        this.openAddUser = false;
        this.openEditUser = true;
        for await (let role of user.role) {
            for await (let r of this.roleList) {
                if (r.id === role) {
                    r.active = true;
                }
            }
        }
    }
    async loadUserByCompanyId(companyId: string) {
        this.companyList = await this.companyService.getCompanyStructureById(companyId);
        this.companyList.forEach(async (company) => {
            let result = await this.companyService.getLicenseByCompanyId(companyId);
            if (result !== false) company.license = result;

            let inviteList = await this.companyService.getInvitesByCompanyId(companyId);
            if (inviteList !== false) company.companyInviteLinkList = inviteList;

        });
        // ToDo: load License by Structured Object direclty serverseitig
    }

    public openUserGateEdit(company:CompanyStructured) {
        this.dialog.open(EditUserGatesComponent, {
            panelClass: "full-width",
            data: company
        })
    }

    protected copyLink(link: InviteLink) {
        if (
            link.expire &&
            new Date().getTime() > link.expire
        ) {
            this.snack.error({
                headline: 'Expired link',
                text: 'The link has expired. Please create a new one',
            });

            return;
        }

        const inviteLink = `${frontendUrl}/login/register?inviteId=${link.id}`;

        this.clipboardService.copyToClipboard(inviteLink);
    }
}
